const title = '导购立屏'

const config = {
    development: {
        // baseUrl: 'http://192.168.1.98:5566/admin'
        baseUrl: 'http://localhost:5566/admin'
    },
    production: {
        baseUrl: 'https://10000.zcondigit.com/admin'
    }
}
const env = process.env

const baseUrl = config[env.NODE_ENV].baseUrl


export {
    title,
    baseUrl
}
